import { css } from "styled-components";

export const SearchGuideStyles = css`
  .card-guide {
    padding: 16px;
    border-radius: 6px;

    &.pages {
      background: #e6f7ff;
    }

    &.transactions {
      background: #fffbe6;
    }
  }
`;
